var map = {
	"./en/administration-adverts.txt": [
		81110,
		729
	],
	"./en/administration-dealflow.txt": [
		60978,
		978
	],
	"./en/dealflow.txt": [
		49083,
		83
	],
	"./en/investment-overview-company-owner-info.txt": [
		72711,
		711
	],
	"./en/learn-about-shareholder-limitation.txt": [
		81734,
		734
	],
	"./en/linked-to-share-register.txt": [
		24048,
		48
	],
	"./en/my-records.txt": [
		22426,
		426
	],
	"./en/portfolio.txt": [
		89235,
		235
	],
	"./en/share-register.txt": [
		65496,
		496
	],
	"./en/shareholder-documents.txt": [
		22033,
		33
	],
	"./en/shareholders.txt": [
		64892,
		511
	],
	"./sv/administration-adverts.txt": [
		12951,
		951
	],
	"./sv/administration-dealflow.txt": [
		43284,
		284
	],
	"./sv/dealflow.txt": [
		42925,
		925
	],
	"./sv/investment-overview-company-owner-info.txt": [
		78585,
		585
	],
	"./sv/learn-about-shareholder-limitation.txt": [
		12244,
		244
	],
	"./sv/linked-to-share-register.txt": [
		76266,
		266
	],
	"./sv/my-records.txt": [
		45108,
		108
	],
	"./sv/portfolio.txt": [
		68985,
		985
	],
	"./sv/share-register.txt": [
		9878,
		878
	],
	"./sv/shareholder-documents.txt": [
		53987,
		987
	],
	"./sv/shareholders.txt": [
		97081,
		81
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 47145;
module.exports = webpackAsyncContext;